// extracted by mini-css-extract-plugin
export var cancelButton = "_oh-5";
export var content = "_oh-3";
export var createButton = "_oh-6";
export var drawerContainer = "_oh-0";
export var footer = "_oh-2";
export var header = "_oh-1";
export var orderFormColumn = "_oh-4";